import { render, staticRenderFns } from "./Offerslist.vue?vue&type=template&id=0d0b4b4f&"
import script from "./Offerslist.vue?vue&type=script&lang=js&"
export * from "./Offerslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports